import React, { useMemo, useRef, useState } from 'react';
import { cn } from '@/lib/utils';

import './project_overview_table_hoverable_item.css';

interface HoverableItemProps {
  className?: string;
  archived?: boolean;
  handleSetRowId?(): void;
  dataQa?: string;
  children?: React.ReactNode;
}

const HoverableItem: React.FC<HoverableItemProps> = ({
  className,
  archived,
  handleSetRowId,
  dataQa,
  children,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const labelRef = useRef<HTMLSpanElement>(null);

  const isEllipsis = useMemo(() => {
    const el = labelRef.current;
    if (!el) return false;
    return el.offsetWidth < el.scrollWidth;
  }, [children]);

  return (
    <div
      className="hoverable_item_container"
      onMouseLeave={() => setIsHovered(false)}
    >
      <span
        ref={labelRef}
        data-qa={dataQa}
        onClick={handleSetRowId}
        onMouseOver={() => setIsHovered(true)}
        className={cn('hoverable_item_label', className)}
        style={archived ? { color: '#6B6B6B' } : undefined}
      >
        {children}
      </span>

      {isHovered && isEllipsis && <div className="hoverable_item_tooltip">{children}</div>}
    </div>
  );
};

export default HoverableItem;
